export default function useApi(gallery: Model.Response<Interfaces.Photo[]>, controller: Customer.Controllers.Photo): Customer.Models.Gallery.Api {
    const store = async (image: File) => {
        const data = new FormData()
        data.append("image", image)
        return controller.store(data)
    }

    const update = controller.update
    const destroy = controller.destroy

    return {
        store,
        update,
        destroy
    }
}